// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Sudan */
const SD = /^(?:(?:1[0-2]|9[0-3569])\d{7})$/;

export default SD;
